module.exports = __webpack_public_path__ + "img/medic.260f6422.svg";